var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-wrapper',{attrs:{"title":"Wallet"}},[_c('div',{staticClass:"page-container"},[_c('div',[_c('wallet-to-earn-user')],1),_vm._v(" "),_c('div',[_c('log-admin-report-by-feature',{attrs:{"target_feature":"TOKENX_TRANSACTION"}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-571b1ca7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/features/morning-coin/pages/WalletToEarnUserPage.vue
// module id = null
// module chunks = 